import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

function header () {
  const body = document.querySelector('body')
  const header = document.querySelector('.l-header')
  const hero = document.querySelector('.l-hero__image')
  let height = header.offsetHeight
  let heroheight = hero.offsetHeight

  updateFixedPosition()

  window.addEventListener('resize', () => {
    height = header.offsetHeight
  })

  window.addEventListener('scroll', () => {
    const scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop
    header.classList.toggle('is-scrolled', scrollTop > height / 2)
    header.classList.toggle('is-white', scrollTop > heroheight - 40)
  })

  document.querySelector('.header-content__meta__burger').addEventListener('click', e => {
    body.classList.toggle('not-scrollable')

    if (body.classList.contains('not-scrollable')) {
      disableBodyScroll(document.querySelector('.header-content__nav'))
      return
    }

    clearAllBodyScrollLocks()
  })

  function updateFixedPosition () {
    setTimeout(() => {
      // header.style.position = 'fixed'
      // body.style.paddingTop = height + 'px'
    }, 0)
  }
}

export default function () {
  header()
}
